export default "__VITE_ASSET__13c5d8b2__"